import DriveLogsIcon from '@motional/inguitiv/svg/logo/drive-logs.svg?react';

function Icon() {
  return <DriveLogsIcon />;
}

export default Icon;
